'use client';

import '@ui5/webcomponents-fiori/dist/Wizard.js';
import { WizardContentLayout } from '../../enums/index.js';
import { withWebComponent } from '../../internal/withWebComponent.js';
/**
 * The `Wizard` helps users to complete a complex task by dividing it into sections and guiding them through it. It has two main areas - a navigation area at the top showing the step sequence and a content area below it.
 *
 * __Note:__ This component is a web component developed by the UI5 Web Components’ team.
 *
 * [UI5 Web Components Storybook](https://sap.github.io/ui5-webcomponents/playground/?path=/docs/fiori-Wizard)
 */
const Wizard = withWebComponent('ui5-wizard', ['contentLayout'], [], [], ['step-change']);
Wizard.displayName = 'Wizard';
Wizard.defaultProps = {
  contentLayout: WizardContentLayout.MultipleSteps
};
export { Wizard };